import {getIniLoggedUser, isTest} from "../session";
import {ESIR_NUMBER, INVOICE_TYPE, PAYMENT_TYPE, TRANSACTION_TYPE} from "../../constants";
import {insertIntoFirestore, insertNewInvoice} from "./index";
import ReactDOMServer from "react-dom/server";
import InvoiceSlip from "../../components/Slip/InvoiceSlip";
import {printPdfLpfr} from "../../api/lpfr";
import QRCode from "qrcode";
import VerificationSlip from "../../components/Slip/VerificationSlip";
import PeronSlip from "../../components/Slip/PeronSlip";
import CouponSlip from "../../components/Slip/CouponSlip";
import TicketSlip from "../../components/Slip/TicketSlip";
import A4TicketSlip, {A4TicketSlipDual} from "../../components/Slip/A4TicketSlip";
import JsBarcode from "jsbarcode";
import {printHTML} from "../index";
import {getCashierName} from "../../utils/other";
import {getCustomerIdentification} from "../other";
import DailyTicketSlip from "../../components/Slip/DailyTicketSlip";
import {getFlixOrderQrCode} from "../../api/flix";
import FlixSlip from "../../components/Slip/FlixSlip";
import {reorderTickets} from "../reorderTickets";

const BUYER_TIN_PREFIX = [10, 11, 12, 20, 21, 22, 23, 30, 32, 33, 34, 35, 40];
const ALL_PAYMENTS_TYPES = [PAYMENT_TYPE.card, PAYMENT_TYPE.cash, PAYMENT_TYPE.check,
    PAYMENT_TYPE.other, PAYMENT_TYPE.voucher, PAYMENT_TYPE.mobileMoney, PAYMENT_TYPE.wireTransfer];
const ALL_INVOICE_TYPES = [INVOICE_TYPE.copy, INVOICE_TYPE.advance, INVOICE_TYPE.normal,
    INVOICE_TYPE.proforma, INVOICE_TYPE.training];

export function convertItemName(name) {
    const chars = {"č": "c", "Č": "C", "ć": "c", "Ć": "c", "đ": "dj", "Đ": "Dj", "š": "s", "Š": "S", "ž": "z", "Ž": "Z"};
    return name?.replace(/[čČćĆđĐšŠžŽ]/g, m => chars[m]);
}

export class Invoice {
    // Main for invoice
    invoice = {
        invoiceNumber: ESIR_NUMBER,
        transactionType: null,
        invoiceType: null,
        buyerId: null,
        dateAndTimeOfIssue: null,
        buyersCosCenter: null,
        referentDocumentNumber: null,
        referentDocumentDT: null,
        payment: null,
        items: null,
        cashier: getCashierName(),
        options: {
            OmitQRCodeGen: "1",
            OmitTextualRepresentation: "0"
        }
    }

    internalData = {
        client: "webBus",
        issuedFor: null,
        cardNumber: null,
        lineNumber: null,
        passenger: null,
        lineType: null,
        discountAmount: null,
    }
    totalCounter;
    // Other
    printLogoInvoice = false;
    printLogoTicket = false;
    ticketValidityPeriod = undefined;
    customer = undefined;
    exchange = undefined;
    logo = undefined;
    ticketLogo = undefined;
    discount = undefined;
    customAdvertisementText = undefined;
    advertisementExtras = undefined;
    silentPrint = false;
    printerSize = null;
    roundedPrice = false;
    responseInvoice = null;

    // ---------------- ZA KREIRANJE RACUNA - NE DIRATI! -------------------------
    setTransactionType = (transaction) => {
        if (transaction !== TRANSACTION_TYPE.refund && transaction !== TRANSACTION_TYPE.sale) {
            throw new Error("Neispravan tip transakcije: ", transaction);
        }
        this.invoice = {
            ...this.invoice,
            transactionType: transaction
        };
    };

    setInvoiceType = (invoiceType) => {
        if (!ALL_INVOICE_TYPES.includes(invoiceType)) {
            throw new Error("Neispravan tip racuna:", invoiceType);
        }
        this.invoice = {
            ...this.invoice,
            invoiceType: invoiceType
        };
    };

    setBuyerIdFromCustomer = (customer) => {
        if (!customer)
            return;
        const taxCorePrefix = parseInt(customer.taxCorePrefix);
        if (!customer.taxCorePrefix) {
            throw new Error("Nije definisan tip kupca!");
        }
        if (!BUYER_TIN_PREFIX.includes(taxCorePrefix)) {
            throw new Error("Nije ispravan tip kupca!", taxCorePrefix);
        }
        if (taxCorePrefix === 12 && !customer.jbkjs) {
            throw new Error("Korisniku nije unet jbkjs!");
        }

        const buyerId = getCustomerIdentification(customer);
        if (buyerId.includes("undefined") || buyerId.includes("null")) {
            throw new Error("Kupcu nije unet identifikacioni broj!");
        }
        this.invoice = {
            ...this.invoice,
            buyerId: buyerId
        };
    };

    setBuyerId = (buyerId) => {
        if (buyerId && !buyerId.includes(":")) {
            throw new Error("buyerId is not valid!");
        }

        this.invoice = {
            ...this.invoice,
            buyerId: buyerId
        };
    };

    setRoundedPrice = (isRounded) => {
        this.roundedPrice = isRounded;
    };
    // allowZero: račun na 0 (overa koja se ne naplaćuje) — inače se nulti iznosi odbacuju
    // i račun ostane bez ijednog načina plaćanja.
    setPayments = (payments, transaction, isRounded, allowZero = false) => {
        payments = payments.filter(item => allowZero ? item.amount >= 0 : item.amount > 0)
        if (!payments || payments.length === 0) {
            throw new Error("Nacini placanja su prazni!");
        }
        if (payments.length === 1) {
            if (isNaN(payments[0].amount) || (!allowZero && payments[0].amount <= 0)) {
                throw new Error(`Nacini placanja ${payments[0].paymentType} je 0 ili nije broj!`);
            }
        } else {
            for (const payment of payments) {
                if (!ALL_PAYMENTS_TYPES.includes(payment.paymentType)) {
                    throw new Error(`Nacini placanja ${payments.paymentType} ne postoji!`);
                }
            }
        }

        const roundPayment = payments.map((payment) => ({
            ...payment,
            amount: transaction !== TRANSACTION_TYPE.refund ? isRounded ? Math.round(payment.amount / 10) * 10 : payment.amount : payment.amount,
        }));
        this.invoice = {
            ...this.invoice,
            payment: roundPayment
        };
    };

    setItems = (items) => {
        if (!items) {
            throw new Error("Morate proslediti proizvode!");
        }
        const requiredFields = ["name", "unitPrice", "quantity", "labels", "totalAmount"];
        let newItems = [];
        for (const item of items) {
            for (const required of requiredFields) {
                if (item[required] === null || item[required] === undefined) {
                    throw new Error(`Morate proslediti ${required}!`);
                }
            }
            let sum = Number(Number(item.quantity).toFixed(3)) * Number(Number(item.unitPrice).toFixed(2));
            sum = Number(Number(sum).toFixed(2));

            if (sum === undefined || isNaN(sum)) {
                throw new Error(`Ukupan iznos za proizvod : ${item.name} nije ispravan!`);
            }

            if (Number(Number(item.totalAmount).toFixed(2)) !== sum) {
                throw new Error(`Ukupan iznos za proizvod: ${item.name} nije tacan!`);
            }

            newItems.push({
                ...item,
                name: convertItemName(item.name),
                quantity: Number(Number(item.quantity).toFixed(3)),
                unitPrice: Number(Number(item.unitPrice).toFixed(2)),
                totalAmount: Number(Number(item.totalAmount).toFixed(2))
            });
        }
        this.invoice = {
            ...this.invoice,
            items: newItems
        };
    };

    setReferentDocumentNumber = (referentDocumentNumber) => {
        this.invoice = {
            ...this.invoice,
            referentDocumentNumber: referentDocumentNumber
        };
    };
    setReferentDocumentDT = (referentDocumentDT) => {
        this.invoice = {
            ...this.invoice,
            referentDocumentDT: referentDocumentDT
        };
    };

    // ----------------- KRAJ KREIRANJA RACUNA -----------------------------------

    setSilentPrint = (silentPrint) => {
        this.silentPrint = silentPrint
    }
    setPrinterSize = (size) => {
        this.printerSize = size
    }
    setExchange = (exchange) => {
        this.exchange = exchange;
    };

    setDiscount = (discount) => {
        this.discount = discount;
    };
    setLogo = (logo) => {
        this.logo = logo;
    };
    setTicketLogo = (logo) => {
        this.ticketLogo = logo;
    };

    setPrintLogoInvoice = (printLogoInvoice) => {
        this.printLogoInvoice = printLogoInvoice;
    };

    setPrintLogoTicket = (printLogoTicket) => {
        this.printLogoTicket = printLogoTicket;
    };

    setCustomAdvertisementText = (item) => {
        this.customAdvertisementText = item;
    };

    setAdvertisementExtras = (extras) => {
        this.advertisementExtras = extras;
    };

    // Reklamni blok na svakoj karti: naslov iz podešavanja (tekst ide posebno, uvek).
    // QR web adrese se više ne štampa; jedini QR u bloku je claim QR na poslednjem slipu.
    buildAdvertisementExtras = async () => {
        const title = this.advertisementExtras?.title?.trim() || "";
        if (!title) return undefined;
        return {title, webAddress: "", webQrDataUrl: null};
    };

    setClaimUrl = (claimUrl) => {
        this.claimUrl = claimUrl;
    };

    // Digitalna kopija karte: QR sa claim linkom kupovine umesto statične reklame.
    // Jedan token vezuje sve karte sa računa, pa se blok štampa samo na poslednjem
    // slipu. Ispod QR-a se ispisuje samo domen — pun link (sa tokenom) je u kodu.
    // ticketCount = broj karata u kupovini (jednina/množina u naslovu). Ispod QR-a ne ide
    // pun link: token od 43 znaka niko ne prekucava, a sam domen ne vodi do karte — zato
    // uputstvo kako se kod koristi, uz domen radi prepoznavanja.
    buildClaimExtras = async (claimUrl, ticketCount = 1) => {
        if (!claimUrl) return undefined;
        const webQrDataUrl = await QRCode.toDataURL(claimUrl, {errorCorrectionLevel: "M", width: 360});
        // Naslov ostaje operaterov ako ga je uneo; podrazumevani samo kad naslova nema.
        const ownTitle = this.advertisementExtras?.title?.trim() || "";
        return {
            title: ownTitle || (ticketCount > 1 ? "Sačuvajte karte na telefonu" : "Sačuvajte kartu na telefonu"),
            webAddress: "Skenirajte kamerom telefona (busgo.travel)",
            webQrDataUrl,
        };
    };

    setIsTrainingModActive = (isTrainingModActive) => {
        this.isTrainingModActive = isTrainingModActive;
    };

    setInternalData = (data) => {
        const internal = {};
        for (const key in data) {
            if (data[key] !== null && data[key] !== undefined) {
                internal[key] = data[key]
            }
        }
        this.internalData = internal
    }

    setTicketExpirationDate = (ticketValidityPeriod) => {
        this.ticketValidityPeriod = ticketValidityPeriod;
    };

    async sendAndPrintInvoice() {
        validateBasicInvoice(this.invoice);
        if (this.isTrainingModActive) {
            this.invoice = {
                ...this.invoice,
                invoiceType: INVOICE_TYPE.training
            };
        }
        let internalData = {
            ...this.internalData
        };

        await insertNewInvoice({
            ...this.invoice,
            internalData
        }).then(async response => {
            this.totalCounter = response.totalCounter
            this.responseInvoice = response;
            await this.printInvoice(this.invoice, response);
        }).catch(async error => {
            const parsed = await handleSendError(error, this.invoice);
            throw new Error(parsed);
        });
    }

    async sendInvoice() {
        validateBasicInvoice(this.invoice);
        if (this.isTrainingModActive) {
            this.invoice = {
                ...this.invoice,
                invoiceType: INVOICE_TYPE.training
            };
        }
        let internalData = {
            ...this.internalData
        };

        await insertNewInvoice({
            ...this.invoice,
            internalData
        }).then(async response => {
            this.totalCounter = response.totalCounter;
            this.responseInvoice = response;
        }).catch(async error => {
            const parsed = await handleSendError(error, this.invoice);
            throw new Error(parsed);
        });
    }

    printVZP = async (firebaseInvoice, tickets, invoice, tin) => {
        this.setBuyerId(tin);
        this.setReferentDocumentNumber(firebaseInvoice.invoiceNumber);
        this.setReferentDocumentDT(firebaseInvoice.sdcDateTime);
        this.setTransactionType(TRANSACTION_TYPE.refund);
        this.setInvoiceType(INVOICE_TYPE.normal);
        this.setItems(invoice.items);
        this.setPayments(invoice.payment)
        await this.printInvoice(this.invoice, invoice);

        this.setInvoiceType(INVOICE_TYPE.copy);
        this.setReferentDocumentNumber(invoice.invoiceNumber);
        this.setReferentDocumentDT(invoice.sdcDateTime);
        await this.sendAndPrintInvoice();


        // Penali za VZP 10%
        this.setTransactionType(TRANSACTION_TYPE.sale);
        this.setInvoiceType(INVOICE_TYPE.normal);
        this.setReferentDocumentNumber(null);
        this.setReferentDocumentDT(null);
        this.setBuyerId(null);
        const forPay = tickets.reduce((acc, item) => acc + item.price, 0) * 0.1;
        this.setPayments([{
            paymentType: PAYMENT_TYPE.cash,
            amount: Number(forPay.toFixed(2))
        }])

        const totalAmountWithAllItems = invoice.items.reduce((acc, item) => {
            return acc + item.totalAmount;
        }, 0);

        // const totalAmount = invoice.items.reduce((acc, item) => {
        //     return item?.passengerUid?.length !== 0 ? acc + item.totalAmount : acc;
        // }, 0);

        //this.setCustomAdvertisementText(`Povraćaj ${(totalAmount - (invoice.items[0].unitPrice * 0.1).toFixed(2))}`)
        this.setItems([{
            name: "Naknada prevoznik " + invoice.items[0].name,
            labels: isTest() ? ['B'] : ['Г'], // TODO KOJA STOPA TREBA OVDE
            quantity: 1,
            unitPrice: Number(Number(forPay / 2).toFixed(2)),
            totalAmount: Number(Number(forPay / 2).toFixed(2)),
        }, {
            name: "Naknada stanica " + invoice.items[0].name,
            labels: isTest() ? ['B'] : ["Ђ"], // TODO KOJA STOPA TREBA OVDE
            quantity: 1,
            unitPrice: Number(Number(forPay / 2).toFixed(2)),
            totalAmount: Number(Number(forPay / 2).toFixed(2)),
        }]);
        this.setExchange(totalAmountWithAllItems - forPay)
        await this.sendAndPrintInvoice();
    }

    storeInvoiceOffline = async (invoice, response) => {
        await insertIntoFirestore(invoice, response);
    }

    printInvoice = async (invoice, response) => {
        if (!this.printLogoInvoice) {
            this.setLogo(undefined);
        }
        try {
            const html = ReactDOMServer.renderToString(InvoiceSlip(invoice, response, this.logo, undefined, this.exchange,
                {
                    text: this.customAdvertisementText
                }, this.ticketValidityPeriod, this.silentPrint, this.printerSize));
            const newHtml = html.replaceAll("replaceToqut", "''");
            if (this.silentPrint) {
                await handleSilentPrint(newHtml, true);
            } else {
                await printHTML(newHtml, false);
            }
        } catch (e) {
            console.error("Invoice printInvoice()", e);
            throw new Error("7532");
        }
    };

    printDailyTicket = async  (tickets,services,advertisementTextTicket, ticketPrintText,actionObjects) => {
        let html = "";
        for (const ticket of tickets) {
            html += ReactDOMServer.renderToString(CouponSlip(
                this.ticketLogo, this.silentPrint, this.printerSize, ticket, true
            ));

            ticket.parsedQR = await QRCode.toDataURL(ticket.forQR, {
                errorCorrectionLevel: 'H',
            });

            html += ReactDOMServer.renderToString(DailyTicketSlip(
                ticket, services,  advertisementTextTicket,  this.ticketLogo,
                this.silentPrint, this.printerSize, actionObjects
            ));
        }

        html = html.replaceAll("replaceToqut", "''");
        await printHTML(html, false);
    }

    //ticketPrintText - ovo je ono sto je uneo kad je pravio dok je advertisementTextTicket sa fb i ima ga uvek
    printTickets = async (tickets, services, allValues, startStation, endStation, advertisementTextTicket,
                          ticketPrintText, maxDaysOfReturn, alSeatNumbered, confirmation, isReturnTicket, linkedStationNames,actionObjects, seatSelectionEnabled, isSelfSale) => {
        let parsedTickets = reorderTickets([...tickets])
        if (!this.printLogoTicket) {
            this.setTicketLogo(undefined);
        }
        // Naslov i tekst idu na svaku kartu; claim QR (jedan token vezuje sve karte sa
        // računa) samo na POSLEDNJI odštampani slip kupovine i samo kad je operater
        // uključio štampu QR-a u podešavanjima.
        const baseExtras = await this.buildAdvertisementExtras();
        const printClaimQr = Boolean(this.claimUrl) && this.advertisementExtras?.claimQrEnabled === true;
        const lastExtras = printClaimQr
            ? await this.buildClaimExtras(this.claimUrl, parsedTickets.length)
            : baseExtras;
        for (let ticket of parsedTickets) {
            ticket.parsedQR = await QRCode.toDataURL(ticket.forQR, {
                errorCorrectionLevel: 'H',
            });
        }
        const lastSilent = parsedTickets[parsedTickets.length - 1];
        const haveReturn = parsedTickets.some(ticket => ticket.isReturnTicket === true);
        if (this.silentPrint) {
            if (parsedTickets.length > 1) {
                if (haveReturn) {
                    // smeru + jedna povratna) niz nije čist par "polazak/povratak", pa bi parsedTickets[i + 1]
                    // bio undefined i pucalo bi pri renderovanju (čitanje .id na undefined). Zato štampamo
                    // svaku kartu pojedinačno, sa kuponom — kao u ostalim granama (jednosmerne / non-silent).
                    for (const ticketData of parsedTickets) {
                        if (!ticketData) continue;
                        if (!confirmation) {
                            let coupon = ReactDOMServer.renderToString(CouponSlip(
                                this.ticketLogo, this.silentPrint, this.printerSize, ticketData,
                            ));
                            coupon = coupon.replaceAll("replaceToqut", "''");
                            await handleSilentPrint(coupon, false);
                        }
                        let ticketHtml = ReactDOMServer.renderToString(TicketSlip(ticketData,
                            services, false, advertisementTextTicket, confirmation, this.ticketLogo,
                            this.silentPrint, this.printerSize,
                            ticketData.isReturnTicket ? maxDaysOfReturn : null,
                            linkedStationNames, actionObjects,
                            seatSelectionEnabled, isSelfSale, ticketData === lastSilent ? lastExtras : baseExtras
                        ));
                        ticketHtml = ticketHtml.replaceAll("replaceToqut", "''");
                        await handleSilentPrint(ticketHtml, false);
                    }
                } else {
                    for (let i = 0; i < parsedTickets.length; i++) {
                        if (!confirmation) {
                            let coupon = ReactDOMServer.renderToString(CouponSlip(
                                this.ticketLogo, this.silentPrint, this.printerSize, parsedTickets[i],
                            ));
                            coupon = coupon.replaceAll("replaceToqut", "''");
                            await handleSilentPrint(coupon, false);
                        }
                        let oneWayTicket = ReactDOMServer.renderToString(TicketSlip(parsedTickets[i],
                            services, false, advertisementTextTicket, confirmation, this.ticketLogo,
                            this.silentPrint, this.printerSize,null, linkedStationNames,actionObjects,
                            seatSelectionEnabled, isSelfSale, parsedTickets[i] === lastSilent ? lastExtras : baseExtras
                        ));
                        let ticket = oneWayTicket.replaceAll("replaceToqut", "''");
                        await handleSilentPrint(ticket, false);
                    }
                }
            } else {
                if (!confirmation) {
                    let coupon = ReactDOMServer.renderToString(CouponSlip(
                        this.ticketLogo, this.silentPrint, this.printerSize, parsedTickets[0]
                    ));
                    coupon = coupon.replaceAll("replaceToqut", "''");
                    await handleSilentPrint(coupon, false);
                }
                let ticketHtml = ReactDOMServer.renderToString(TicketSlip(
                    parsedTickets[0], services, false, advertisementTextTicket, confirmation, this.ticketLogo,
                    this.silentPrint, this.printerSize, maxDaysOfReturn,linkedStationNames,actionObjects,
                    seatSelectionEnabled, isSelfSale, lastExtras
                ));
                ticketHtml = ticketHtml.replaceAll("replaceToqut", "''");
                await handleSilentPrint(ticketHtml, false);
            }
        } else {
            let reorderedTickets = tickets;

            if (isReturnTicket && tickets.length > 1) {
                const mid = Math.ceil(tickets.length / 2);
                const firstHalf = tickets.slice(0, mid);
                const secondHalf = tickets.slice(mid);

                reorderedTickets = [];
                for (let i = 0; i < firstHalf.length; i++) {
                    reorderedTickets.push(firstHalf[i]);
                    if (secondHalf[i]) reorderedTickets.push(secondHalf[i]);
                }
            }

            // ✅ Svaka karta zasebno
            for (const ticket of reorderedTickets) {
                let oneTicketHtml = "";

                if (!confirmation) {
                    oneTicketHtml += ReactDOMServer.renderToString(
                        CouponSlip(this.ticketLogo, this.silentPrint, this.printerSize, ticket)
                    );
                }

                oneTicketHtml += ReactDOMServer.renderToString(
                    TicketSlip(
                        ticket, services, false, advertisementTextTicket, confirmation, this.ticketLogo,
                        this.silentPrint, this.printerSize, maxDaysOfReturn, linkedStationNames, actionObjects,
                        seatSelectionEnabled, isSelfSale,
                        ticket === reorderedTickets[reorderedTickets.length - 1] ? lastExtras : baseExtras
                    )
                );

                oneTicketHtml = oneTicketHtml.replaceAll("replaceToqut", "''");
                await printHTML(oneTicketHtml, false);
            }
        }
    }

    printA4Tickets = async (tickets, services, advertisementTextTicket,
                            maxDaysOfReturn, confirmation, isReturnTicket, actionObjects, seatSelectionEnabled, isSelfSale, invoiceLine) => {
        if (!this.printLogoTicket) {
            this.setTicketLogo(undefined);
        }
        let parsedTickets = reorderTickets([...tickets]);
        for (let ticket of parsedTickets) {
            ticket.parsedQR = await QRCode.toDataURL(ticket.forQR, {
                errorCorrectionLevel: 'H',
            });
        }

        const oneWayTickets = parsedTickets.filter(t => !t.isReturnTicket);
        const returnTickets = parsedTickets.filter(t => t.isReturnTicket);

        const generateBarcode = (text) => {
            try {
                const canvas = document.createElement("canvas");
                JsBarcode(canvas, String(text), {
                    format: "CODE128",
                    width: 2,
                    height: 50,
                    displayValue: false,
                    margin: 0,
                });
                return canvas.toDataURL("image/png");
            } catch (e) {
                console.error("Barcode generation failed", e);
                return null;
            }
        };

        const arrTripTime = invoiceLine?.arrTripTime || null;
        // Kontakt na A4 karti je kontakt prodavca: glavni nalog prijavljen na kasu
        // (odgovor /operator/me sačuvan pri prijavi), ne prevoznik sa karte.
        const sellerDetails = getIniLoggedUser()?.operatorDetails;
        const carrierContact = {
            phone: sellerDetails?.phone || null,
            email: sellerDetails?.email || null,
            webAddress: sellerDetails?.webAddress || null,
            platformContact: "BusSoft - https://app.bussoft.rs/home"
        };

        const haveReturn = returnTickets.length > 0;

        if (haveReturn) {
            // Povratne karte: po putnicima parovi (jedan smer + povratna) na istom A4
            for (let i = 0; i < oneWayTickets.length; i++) {
                const outbound = oneWayTickets[i];
                const ret = returnTickets[i];
                if (outbound && ret) {
                    const outBarcode = generateBarcode(outbound.id || outbound.externalTicketId || "");
                    const retBarcode = generateBarcode(ret.id || ret.externalTicketId || "");
                    // A4: POLAZAK + POVRATAK + KUPONI na istom papiru
                    let html = ReactDOMServer.renderToString(
                        A4TicketSlipDual(
                            outbound, ret, services, this.ticketLogo,
                            seatSelectionEnabled, isSelfSale, actionObjects,
                            outBarcode, retBarcode, arrTripTime,
                            maxDaysOfReturn, carrierContact, confirmation, advertisementTextTicket
                        )
                    );
                    html = html.replaceAll("replaceToqut", "''");
                    await printHTML(html, true);
                }
            }
        } else {
            // Jednosmerne: svaka karta + kupon na jednom A4
            for (const ticket of oneWayTickets) {
                const barcodeDataUrl = generateBarcode(ticket.id || ticket.externalTicketId || "");
                let html = ReactDOMServer.renderToString(
                    A4TicketSlip(ticket, services, this.ticketLogo, seatSelectionEnabled, isSelfSale, actionObjects, barcodeDataUrl, arrTripTime, maxDaysOfReturn, carrierContact, advertisementTextTicket)
                );
                html = html.replaceAll("replaceToqut", "''");
                await printHTML(html, true);
            }
        }
    }

    printVerification = async (dataList, user) => {
        if (!this.printLogoTicket) {
            this.setTicketLogo(undefined);
        }

        const slipDataList = await Promise.all(
            dataList.map(async (data) => {
                const qrCodeUrl = await QRCode.toDataURL(`${data.ticketId}`);
                return {
                    ...data,
                    qrCodeUrl,
                    service: this.invoice.items[0],
                    ticketLogo: this.ticketLogo,
                };
            })
        );

        if (this.silentPrint) {
            for (const slip of slipDataList) {
                let oneHtml = ReactDOMServer.renderToString(
                    VerificationSlip([slip], this.silentPrint, this.printerSize, user)
                );
                oneHtml = oneHtml.replaceAll("replaceToqut", "''");
                await handleSilentPrint(oneHtml, false);
            }
        } else {
            let html = ReactDOMServer.renderToString(
                VerificationSlip(slipDataList, this.silentPrint, this.printerSize, user)
            );
            html = html.replaceAll("replaceToqut", "''");
            await printHTML(html, false);
        }
    };


    printPeron = async (peronId, additional, user) => {
        if (!this.printLogoTicket) {
            this.setTicketLogo(undefined);
        }
        const qrCodeUrl = await QRCode.toDataURL(`${peronId}`);
        const html = ReactDOMServer.renderToString(PeronSlip(peronId, {
                ...this.invoice.items[0],
                cashier: this.invoice.cashier
            }, this.ticketLogo,
            qrCodeUrl, this.silentPrint, this.printerSize, additional, user));
        const newHtml = html.replaceAll("replaceToqut", "''");
        if (this.silentPrint) {
            await handleSilentPrint(newHtml, false);
        } else {
            await printHTML(newHtml, false);
        }
    }
    printFlixCoupon = async (flixTicket,additional, user) => {
        if (!this.printLogoTicket) {
            this.setTicketLogo(undefined);
        }
        const qrData = (await getFlixOrderQrCode(flixTicket.id, flixTicket.token)).data
        const html = ReactDOMServer.renderToString(FlixSlip(
            flixTicket.id,
            flixTicket?.contact?.email,
            flixTicket?.contact?.phone,
            {
                ...this.invoice.items[0],
                cashier: this.invoice.cashier
            }, this.ticketLogo,
            qrData || [], this.silentPrint, this.printerSize,additional, user));
        const newHtml = html.replaceAll("replaceToqut", "''");
        if (this.silentPrint) {
            await handleSilentPrint(newHtml, false);
        } else {
            await printHTML(newHtml, false);
        }
    }
}

const handleSendError = async (error) => {
    let parsed = error;
    if (error?.message === "7532" || error?.message === "7533") {
        parsed = "Račun je poslat u PU, ali greška prilikom štampanja";
    } else if (error?.message === "Bad Request") {
        parsed = "Došlo je do greške prilikom izdavanja računa";
    } else if (typeof error === "string") {
        parsed = error;
    } else if (typeof error?.message === "string") {
        parsed = error.message;
    }
    return parsed;
};

const validateBasicInvoice = (invoice) => {
    const requiredFields = ["transactionType", "cashier", "invoiceType", "payment", "items"];
    for (const requiredField of requiredFields) {
      if (!invoice[requiredField]) {
        throw new Error(`Field ${requiredField} is required!`);
      }
    }
    if (invoice.invoiceType === INVOICE_TYPE.copy || invoice.transactionType === TRANSACTION_TYPE.refund) {
        if (!invoice.referentDocumentNumber) {
            throw new Error(`Field referentDocumentNumber is required!`);
        }
        if (!invoice.referentDocumentDT) {
            throw new Error(`Field referentDocumentDT is required!`);
        }
    }
    let paymentsSum = invoice.payment.reduce((acc, {amount}) => acc + Number(amount), 0);
    let itemsSum = invoice.items.reduce((acc, {totalAmount}) => acc + Number(totalAmount), 0);
    console.debug("validateBasicInvoice", paymentsSum, itemsSum);

    if (paymentsSum !== itemsSum) {
        throw new Error("Ukupan iznos za placanje i ukupan iznos proizvoda se ne poklapa ");
    }
};

export const handleSilentPrint = async (html, isInvoice) => {
    let name = 'ticket.html'
    html = html.replaceAll("colSpan", "colspan");
    if (isInvoice) {
        html = html.replaceAll("class=\"dashedDivider\">",
            ">==============================");
        html = html.replaceAll("class=\"dashedDividerLine\">",
            ">------------------------------------------------");
        name = 'invoice.html'
    }
    const blob = new Blob([html], {type: 'text/html'});
    const formData = new FormData();
    formData.append('file', blob, name);
    await printPdfLpfr(formData);
}
